export default __webpack_public_path__ + "static/media/aircraft-industry.33837eac.jpg";